import { MonthYear } from "@common/types";
import { ICommandBase } from "@Quest/cqrs";

export class CreatePortfolioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.CreatePortfolioCommandV1, TCh.Domain.Quest';

	StrategyWorkspaceId: number;
	PortfolioWorkspaceId: number;
	StrategyId: string;
	Id: string;
	Name: string;
	Description: string;

	constructor(strategyWorkspaceId: number, portfolioWorkspaceId: number, strategyId: string, portfolioId: string, name: string, description: string)
	{
		this.StrategyWorkspaceId = strategyWorkspaceId;
		this.PortfolioWorkspaceId = portfolioWorkspaceId;
		this.StrategyId = strategyId;
		this.Id = portfolioId;
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.CreatePortfolioCommandV1, TCh.Domain.Quest'
	}
}

export class LinkPortfolioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.LinkPortfolioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	StrategyId: string;
	Id: string;
	PortfolioWorkspaceId: number;
	PortfolioTchProjectId: number;

	constructor(workspaceId: number, strategyId: string, portfolioId: string, portfolioWorkspaceId: number, portfolioTchProjectId: number)
	{
		this.WorkspaceId = workspaceId;
		this.StrategyId = strategyId;
		this.Id = portfolioId;
		this.PortfolioWorkspaceId = portfolioWorkspaceId;
		this.PortfolioTchProjectId = portfolioTchProjectId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.LinkPortfolioCommandV1, TCh.Domain.Quest'
	}
}


export class UpdatePortfolioSettingsCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.UpdatePortfolioSettingsCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Name: string;
	Description: string | null;
	BenefitsConfidenceDate: MonthYear | null;

	ExcludedResourceIds: string[];
	ExcludedRevenueIds: string[];
	ExcludedExpenseIds: string[];
	ExcludedCapexIds: string[];

	constructor(workspaceId: number, portfolioId: string, name: string, description: string | null, benefitsConfidenceDate: MonthYear | null,
		excludedResourceIds: string[], excludedRevenueIds: string[], excludedExpenseIds: string[], excludedCapexIds: string[])
	{
		this.WorkspaceId = workspaceId;
		this.Id = portfolioId;
		this.Name = name;
		this.Description = description;
		this.BenefitsConfidenceDate = benefitsConfidenceDate;
		this.ExcludedResourceIds = excludedResourceIds;
		this.ExcludedCapexIds = excludedCapexIds;
		this.ExcludedExpenseIds = excludedExpenseIds;
		this.ExcludedRevenueIds = excludedRevenueIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.UpdatePortfolioSettingsCommandV1, TCh.Domain.Quest'
	}
}



export class DeletePortfolioCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.DeletePortfolioCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;

	constructor(workspaceId: number, portfolioId: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = portfolioId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.DeletePortfolioCommandV1, TCh.Domain.Quest'
	}
}

export class ImportProjectPlansFromSpreadsheetCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.ImportProjectPlansFromSpreadsheetCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	BlobId: string;
	ImportedPlanName: string;

	constructor(workspaceId: number, portfolioId: string, blobId: string, importedPlanName: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = portfolioId;
		this.BlobId = blobId;
		this.ImportedPlanName = importedPlanName;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.ImportProjectPlansFromSpreadsheetCommandV1, TCh.Domain.Quest'
	}
}


export class ExportAllActiveProjectPlansCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.ExportAllActiveProjectPlansCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	constructor(workspaceId: number, portfolioId: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = portfolioId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type == 'TCh.Domain.Quest.Portfolios.Commands.ExportAllActiveProjectPlansCommandV1, TCh.Domain.Quest'
	}
}




export class SaveViewProposedProjectsPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewProposedProjectsPageCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, portfolioId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = portfolioId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Portfolios.Commands.SaveViewProposedProjectsPageCommandV1, TCh.Domain.Quest';
	}
}

export class SaveViewScheduledProjectsPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewScheduledProjectsPageCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, portfolioId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = portfolioId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Portfolios.Commands.SaveViewScheduledProjectsPageCommandV1, TCh.Domain.Quest';
	}
}

export class SaveViewStartedProjectsPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewStartedProjectsPageCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, portfolioId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = portfolioId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Portfolios.Commands.SaveViewStartedProjectsPageCommandV1, TCh.Domain.Quest';
	}
}

export class SaveViewFinishedProjectsPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewFinishedProjectsPageCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, portfolioId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = portfolioId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Portfolios.Commands.SaveViewFinishedProjectsPageCommandV1, TCh.Domain.Quest';
	}
}

export class SaveViewAllProjectsPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewAllProjectsPageCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, portfolioId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = portfolioId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Portfolios.Commands.SaveViewAllProjectsPageCommandV1, TCh.Domain.Quest';
	}
}

export class SaveViewOwnerProjectsPageCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Quest.Portfolios.Commands.SaveViewOwnerProjectsPageCommandV1, TCh.Domain.Quest';

	WorkspaceId: number;
	Id: string;
	Grid: string;

	constructor(workspaceId: number, portfolioId: string, grid: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = portfolioId;
		this.Grid = grid;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Quest.Portfolios.Commands.SaveViewOwnerProjectsPageCommandV1, TCh.Domain.Quest';
	}
}



